import { render } from "./menu.vue?vue&type=template&id=62e19422&scoped=true"
import script from "./menu.vue?vue&type=script&lang=js"
export * from "./menu.vue?vue&type=script&lang=js"

import "./menu.vue?vue&type=style&index=0&id=62e19422&lang=scss&scoped=true"
import "./menu.vue?vue&type=style&index=1&id=62e19422&lang=scss"
script.render = render
script.__scopeId = "data-v-62e19422"

export default script